import { Controller } from "@hotwired/stimulus";

/**
 * Caps how many checkboxes of a group can be ticked (e.g. the 8 indicators
 * of a comparison): once the maximum is reached the other boxes are
 * disabled, and the counter shows "n / max".
 */
export default class extends Controller {
  static targets = ["box", "count"];
  static values = { max: Number };

  connect() {
    this.update();
  }

  update() {
    const checked = this.boxTargets.filter((box) => box.checked).length;
    const full = checked >= this.maxValue;
    this.boxTargets.forEach((box) => {
      box.disabled = full && !box.checked;
      box.closest("label")?.classList.toggle("opacity-50", box.disabled);
    });
    if (this.hasCountTarget) this.countTarget.textContent = `${checked} / ${this.maxValue}`;
  }
}
